module.exports = __webpack_public_path__ + "static/2-new_mobile-8ec041dcaa989510758b65ac2ebb2bde.jpg";